<template>
  <div class="expert-swiper-container">
    <div class="expert-wrap main-width">
      <v-title title="本院学者" url="/views/agency/expert" />
      <div class="expert-content">
        <div class="swiper-container-outer">
          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide class="swiper-expert-item" v-for="(item, index) in expertList" :key="index">
              <ExpertItem :info="item"></ExpertItem>
            </swiper-slide>
          </swiper>
          <!-- 分页 -->
          <!-- <div class="swiper-pagination my-swiper-pagination swp-page1"></div> -->
          <!-- 左按钮 -->
          <div class="swiper-button-prev my-swiper-button swp1"></div>
          <!-- 右按钮 -->
          <div class="swiper-button-next my-swiper-button swp1"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VTitle from "./components/title/index";
import ExpertItem from "./components/expert/index";

import SwiperCore, { Navigation, Pagination } from "swiper";
// Import Swiper styles
import "swiper/swiper.less";
import "swiper/components/navigation/navigation.less";
import "swiper/components/pagination/pagination.less";
// install Swiper modules
SwiperCore.use([Navigation, Pagination]);

export default {
  data() {
    return {
      swiperOptions: {
        loop: false,
        autoplay: false,
        slidesPerView: 4, //显示个数
        spaceBetween: 10,
        touchStartPreventDefault: false, // 不阻止事件
        observer: true,
        observerParents: true,
        // pagination: {
        //   el: ".swiper-pagination.swp-page1",
        //   clickable: true,
        // },
        navigation: {
          nextEl: ".swiper-button-next.swp1",
          prevEl: ".swiper-button-prev.swp1",
        },
        breakpoints: {
          //当宽度大于等于768
          768: {
            slidesPerView: 1,
            spaceBetween: 10
          }
        }

      },
    }
  },
  props: {
    expertList: {
      type: Array,
      default: () => []
    },
  },
  components: {
    VTitle,
    ExpertItem
  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.expert-swiper-container {
  padding-bottom: 30px;
  .expert-content {
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    height: 380px;
    .swiper-expert-item {
      width: calc((100% - 100px) / 4);
      padding: 0 10px;
    }
  }
  .swiper-container-outer {
    width: 100%;
    height: 100%;
    position: relative;
    .slide-content {
      width: 100%;
      height: 100%;
      position: relative;
      background-position: center center;
      background-size: cover;
      .el-image {
        width: 100%;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .my-swiper-pagination {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      /deep/ .swiper-pagination-bullet {
        width: 8px;
        height: 8px;
        border-radius: 100%;
        margin: 0 6px;
        background: #2960a7;
      }
    }
    .my-swiper-button {
      // width: 30px;
      background: transparent;
      color: #2960a7;
      border-radius: 2px;
      &.swiper-button-prev {
        left: -20px;
      }
      &.swiper-button-next {
        right: -20px;
      }
      &::after {
        font-size: 30px;
        font-weight: bold;
      }
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      .swiper-slide {
        color: #fff;
        > div {
          height: 100%;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .expert-swiper-container {
    .expert-content {
      display: block;
      padding: 0;
      height: auto;
      margin-top: 14px;
      .swiper-expert-item {
        width: 100% !important;
        padding: 0 26px;
      }
    }
    .swiper-container-outer {
      .my-swiper-pagination {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        /deep/ .swiper-pagination-bullet {
          width: 8px;
          height: 8px;
          border-radius: 100%;
          margin: 0 6px;
          background: #2960a7;
        }
      }
      .my-swiper-button {
        background: transparent;
        color: #2960a7;
        border-radius: 2px;
        &.swiper-button-prev {
          left: 0px;
        }
        &.swiper-button-next {
          right: 0px;
        }
        &::after {
          font-size: 20px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>